import { GIVRECOEUR } from './meadow-dragon.js';
import { ELDER, HUNTER, SCHOLAR } from './swamp-village.js';
/**
 * The swamp's mark of the dragon (ADR 0067, `docs/LORE.md`): after the troll,
 * la Traqueuse Nella follows a trail that falls from the sky to l'Empreinte,
 * a claw-shaped crater where the mud boiled, and understands that Shefira
 * landed there to feed: she is taking her strength back before she strikes.
 * The Érudit Théophane finds her in the drowned texts, and a king of the
 * south who paid her a tribute (the desert's thread). Then Nella joins the
 * Givrecoeur Company at Havrebourg. The road south waits for her recruitment.
 */
export const SWAMP_DRAGON_QUESTS = [
    {
        id: 'swamp-dragon-print',
        name: 'L’Empreinte',
        biome: 'swamp',
        level: 12,
        requires: ['swamp-troll'],
        giver: HUNTER,
        turnIn: HUNTER,
        offer: 'Le troll est battu, mais ce n’est pas lui qui mangeait mes caïmans. Il en disparaît des entiers, sans laisser un os ! J’ai suivi la trace, et elle ne commence nulle part… comme si la bête était tombée du ciel. Elle finit à un endroit qu’on appelle l’Empreinte. Viens voir. Et attention aux caïmans là-bas, ils sont devenus fous.',
        summary: 'Rejoindre l’Empreinte, abattre les caïmans affolés qui y rôdent, puis revenir à la Traqueuse Nella.',
        pending: 'Tu reconnaîtras l’Empreinte à la vapeur : la vase y bout encore ! Bats les caïmans qui rôdent autour.',
        complete: 'Regarde la forme du trou : c’est une patte ! Quatre doigts, avec des griffes longues comme mon bras. Et tout autour, des os de caïmans rongés. Le dragon ne faisait pas que passer, il s’est posé ici pour manger. Il reprend des forces.',
        objectives: [
            { kind: 'reach', label: 'Atteindre l’Empreinte', landmark: 'L’Empreinte' },
            { kind: 'kill', label: 'Caïmans affolés abattus', mobs: ['caiman-maddened'], count: 12 },
        ],
        reward: { xp: 650, gold: 130 },
    },
    {
        id: 'swamp-dragon-texts',
        name: 'La Faim rouge',
        biome: 'swamp',
        level: 12,
        requires: ['swamp-dragon-print'],
        giver: HUNTER,
        turnIn: SCHOLAR,
        offer: 'Moi, je sais pister une bête, pas lire les vieilles écritures. Théophane, lui, sait. Va lui raconter ce qu’on a vu. Et au passage, chasse les hommes-lézards qui fouillent les os, je ne veux pas qu’ils touchent à ce que la bête a laissé.',
        summary: 'Chasser les hommes-lézards qui fouillent l’Empreinte, puis raconter à l’Érudit Théophane ce qu’on y a vu.',
        pending: 'Chasse les hommes-lézards autour de l’Empreinte, puis va voir Théophane aux Ruines Noyées, au sud-est. Il sera content de te voir. Il est toujours content.',
        complete: 'Quatre doigts ? Et une écaille rouge ? Attends, attends… Colonne sept ! Les anciens lézards l’appelaient la Faim rouge. Ils racontent qu’un roi du sud la payait pour qu’elle ne brûle pas son royaume. Mais son nom à lui a été effacé, regarde, quelqu’un l’a gratté exprès ! Quelle histoire passionnante !',
        objectives: [{ kind: 'kill', label: 'Hommes-lézards chassés', mobs: ['lizardman'], count: 14 }],
        reward: { xp: 600, gold: 120, items: [{ templateId: 'swamp-potion', quantity: 2 }] },
    },
    {
        id: 'swamp-recruit',
        name: 'La traqueuse de la Compagnie',
        biome: 'swamp',
        level: 12,
        requires: ['swamp-dragon-texts'],
        giver: HUNTER,
        turnIn: GIVRECOEUR,
        offer: 'Toute ma vie, j’ai chassé des bêtes qui nagent. Celle-là vole, et je veux la voir de près ! Ton chevalier va avoir besoin de pièges assez gros pour la bloquer au sol. Ça tombe bien, c’est ma spécialité. Préviens la Doyenne. Elle va pleurer, fais semblant de ne rien voir.',
        summary: 'Prévenir la Doyenne Ombeline, puis rejoindre Ser Givrecoeur au quartier de la Compagnie, à Havrebourg.',
        pending: 'Préviens la Doyenne sur la place, puis va voir Ser Givrecoeur à Havrebourg. Je prends mes cordes et j’arrive.',
        complete: 'Le dragon se pose pour manger ? Alors il n’a pas encore retrouvé toute sa force. Bonne nouvelle, on a encore un peu de temps ! Bienvenue, Nella. Tes pièges seront parfaits pour le clouer au sol. La tente près du feu est libre.',
        objectives: [
            {
                kind: 'talk',
                label: 'Prévenir la Doyenne',
                npc: ELDER,
                line: 'Nella s’en va ? Je l’ai vue naître, tu sais. Elle mordait déjà tout le monde. Allez, va. Et ramène-la-moi, que je la voie enfin au soleil.',
            },
        ],
        reward: { xp: 400, gold: 80 },
    },
];
//# sourceMappingURL=swamp-dragon.js.map